import GCheckbox from './GCheckbox.vue';

export default GCheckbox;

export { GCheckbox };
